// import { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { GetUserPaymentMethod } from "../../../Actions/StudentA";
// import Visa from "../Assets/VisaImage.svg";
// import Paypal from "../PaymentMethod/Assets/PaypalMethod.png"
// import CreditCard from "../PaymentMethod/Assets/CreditCardMethod.svg"
// import GooglePay from "../PaymentMethod/Assets/GooglePayMethod.png"
// import ApplePay from "../PaymentMethod/Assets/ApplePayMethod.png"
// import BankTransfer from "../PaymentMethod/Assets/BankTransferMethod.svg"

// const UserPaymentAdded = ({UserId}) => {
//     const Dispatch = useDispatch();
//     const { UserPaymentMethodData } = useSelector((Store) => Store.StudentReducer);
//     console.log("UserPaymentMethodData from database is:",UserPaymentMethodData)
//     useEffect(() => {
//         if(UserId){
//          Dispatch(GetUserPaymentMethod(UserId))
//         }
//        }, [UserId, Dispatch]);

//   return (
//     <div className="w-full flex flex-col gap-[10px]">
//         <div className="w-[100%] flex flex-col gap-[10px] bg-[#F8FAFA] rounded-[9px] px-[15px] py-[15px]">
//             <div className="w-full bg-[#FFFFFF] px-[25px] py-[30px] flex"
//             style={{border:"1px solid #D6D6D6"}}>
//                 <div className="flex flex-col items-start gap-[10px] w-[25%]">
//                     <p className="text-[18px] font-bold text-[#000000]">Master Card</p>
//                     <img src={Visa} alt="visa" className="h-[40px] ml-[15px]" />
//                 </div>
//                 <div className="flex flex-col gap-[10px] mt-[15px] w-[60%]">
//                     <p className="text-[17px] text-[#000000]">**** **** **** 1111</p>
//                     <p className="text-[17px] text-[#000000]">Exp: 03/2025</p>
//                 </div>
//                 <div className="h-full flex justify-center items-center w-[25%]">
//                     <p className="text-[18px] text-[#000000] font-bold">Default</p>
//                 </div>
//             </div>           
//         </div>
//     </div>
//   );
// };

// export default UserPaymentAdded;

import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetUserPaymentMethod, UpdateUserPaymentDefaultField } from "../../../Actions/StudentA";
import Visa from "../Assets/VisaImage.svg";
// import Paypal from "../PaymentMethod/Assets/PaypalMethod.png";
import Paypal from "../PaymentMethod/Assets/paypalPaymentimg.png";
import CreditCard from "../PaymentMethod/Assets/CreditCardMethod.svg";
import GooglePay from "../PaymentMethod/Assets/GooglePayMethod.png";
import ApplePay from "../PaymentMethod/Assets/ApplePayMethod.png";
import BankTransfer from "../PaymentMethod/Assets/BankTransferMethod.svg";
import SettingsPopup from "../Popups/Popups";

const UserPaymentAdded = ({ UserId }) => {
  const Dispatch = useDispatch();
  const { UserPaymentMethodData } = useSelector((Store) => Store.StudentReducer);
  console.log("UserPaymentMethodData is:",UserPaymentMethodData)
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (UserId) {
      Dispatch(GetUserPaymentMethod(UserId));
    }
  }, [UserId, Dispatch]);

  // Mask function to partially hide sensitive data
  const maskData = (data, type) => {
    if (type === "paypal" || type === "googlepay" || type === "applepay") {
      // Masking email - Show first part and hide the rest with asterisks
      const [username, domain] = data.split("@");
      return `${username.substring(0, 3)}***@${domain}`;
    } else if (type === "creditcard") {
      // Masking card number - Show last 4 digits, rest as asterisks
      return `**** **** **** ${data.slice(-4)}`;
    } else if (type === "bankaccount") {
      // Masking bank account number - Show last 4 digits, rest as asterisks
      return `**** **** **** ${data.slice(-4)}`;
    }
    return data; // Default case
  };

  const handleDefaultSelection = async (paymentMethodId, isSelectDefault) => {
    if (isSelectDefault === "default") return; // Do nothing if already default

    Dispatch(UpdateUserPaymentDefaultField(UserId,paymentMethodId))
    .then(() => {
      setShowPopup(true); // Show popup on successful update
      // Refresh the page after 5 seconds
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    })
    .catch((error) => {
      console.error("Error updating settings:", error);
      // Handle error if needed
    });
  }

  return (
    <>
       {UserPaymentMethodData.length > 0 && (
          <div className="w-full flex flex-col justify-center items-center gap-[15px]">
            <div className="w-[90%] hidden lg:flex flex-start">
                <p className="text-[#404040] text-[20px] font-bold">Saved Payment Method</p>
            </div>

              <div className="w-[90%] flex flex-col gap-[10px] lg:gap-[20px] lg:bg-[#F8FAFA] rounded-[9px] px-[0px] lg:px-[15px] lg:py-[15px]">
                  {UserPaymentMethodData && UserPaymentMethodData.map((payment, index) => {
                      let imageSrc = "";
                      let displayData = "";
                      let paymentTypeName = "";
                      const { PaymentMethodId,PaymentType, PaypalEmail, GooglePayEmail, ApplePayEmail, CreditCardCardNumber, CreditCardExpiryDate, BankAccountAccountNumber, IsSelectDefault } = payment;

                      // Dynamically choose payment method image and data
                      switch (PaymentType) {
                      case "paypal":
                          imageSrc = Paypal;
                          paymentTypeName = "PayPal";
                          displayData = maskData(PaypalEmail, "paypal");
                          break;
                      case "googlepay":
                          imageSrc = GooglePay;
                          paymentTypeName = "Google Pay";
                          displayData = maskData(GooglePayEmail, "googlepay");
                          break;
                      case "applepay":
                          imageSrc = ApplePay;
                          paymentTypeName = "Apple Pay";
                          displayData = maskData(ApplePayEmail, "applepay");
                          break;
                      case "creditCard":
                          imageSrc = CreditCard;
                          paymentTypeName = "Credit Card";
                          displayData = maskData(CreditCardCardNumber, "creditcard");
                          break;
                      case "BankAccount":
                          imageSrc = BankTransfer;
                          paymentTypeName = "Bank Account";
                          displayData = maskData(BankAccountAccountNumber, "bankaccount");
                          break;
                      default:
                          return null;
                      }

                      return (
                          <div key={index} className="w-full bg-[#FFFFFF] px-[10px] lg:px-[25px] py-[10px] lg:py-[30px] flex" style={{ border: "1px solid #D6D6D6" }}>
                          <div className="flex flex-col items-start gap-[10px] w-[25%]">
                              <p className="text-[18px] font-bold text-[#000000]">{paymentTypeName}</p>
                              <img src={imageSrc} alt={paymentTypeName} className="lg:ml-[15px]" />
                          </div>
                          <div className="flex flex-col gap-[10px] lg:mt-[15px] w-[60%]">
                              <p className="text-[17px] text-[#000000]">{displayData}</p>
                              {PaymentType === "creditcard" && CreditCardExpiryDate && (
                              <p className="text-[17px] text-[#000000]">Exp: {CreditCardExpiryDate}</p>
                              )}
                          </div>
                          <div className="h-full flex justify-center items-center w-[25%]">
                              <p
                                className={`text-[18px] text-[#000000] font-bold ${
                                  IsSelectDefault === "select" ? "cursor-pointer" : "cursor-not-allowed opacity-50"
                                }`}
                                onClick={() => handleDefaultSelection(PaymentMethodId, IsSelectDefault)}
                              >
                                {IsSelectDefault}
                              </p>    
                          </div>
                          </div>
                      );
                  })}

                  {showPopup && (
                      <SettingsPopup
                          setShowPopup={setShowPopup}
                          text="Payment Method updated"
                      />
                  )}
              </div>
          </div>
       )}
    </>
  );
};

export default UserPaymentAdded;

